
import { Routes, Route } from 'react-router-dom';


import AppLayout from './components/Layout/AppLayout';
import DashBoard from './pages/dashboard/DashBoard';
import EmployeeDetails from './pages/employees/EmployeesDetails/EmployeeDetails';
import EmployeeAdd from './pages/employees/EmployeesAdd/EmployeeAdd';
import EmployeeEdit from './pages/employees/EmployeesEdit/EmployeeEdit';

import AllAsset from './pages/assetsManage/AssetSum/AssetSum';
import Assets from './pages/assetsManage/Assets/Assets';
import AssetDetails from './pages/assetsManage/AssetDetails/AssetDetails';
import AssetAdd from './pages/assetsManage/AssetAdd/AssetAdd';
import AssetEdit from './pages/assetsManage/AssetEdit/AssetEdit';

import AllAssign from './pages/assign/AssignSummary/AssignSummary';
import Assign from './pages/assign/Assign/Assign';
import AssignAsset from './pages/assign/AssignAdd/AssignAdd';
import AssignDetails from './pages/assign/AssignDetails/AssignDetails';
import AssignEdit from './pages/assign/AssignEdit/AssignEdit';
import AssignLogs from './pages/assign/AssignLogs/AssignLogs';
import Login from './pages/login/Login';
import NotFound from './pages/login/NotFound';
import AllEmployees from './pages/employees/AllEmployees/AllEmployees';
import PrivateRoute from './components/PivateRoutes/PrivateRoute';
import ResetPassword from './components/ResetPassword/ResetPassword';
import ChangePassword from './components/ChangePassword/ChangePassword';
import { ToastContainer, Slide } from 'react-toastify';
import AssignLogsByAssets from './pages/logs/AssignLogsByAsset';

import { useEffect } from "react";
import { dynamicTheme } from "./utils/dynamicTheme";
import AssetTypePage from './pages/assetsManage/AssetType/AssetType';



function App() {

  useEffect(() => {
    const theme = sessionStorage.getItem("tenantTheme");
    if (theme) {
      dynamicTheme(JSON.parse(theme));
    }
  }, []);

  return (
    <>
      <Routes>
        {/* AppLayout draws Navbar + Sidebar once */}

        <Route path="/login/:tenant" element={<Login />} />
        {/* 404 page */}
        <Route path="/404" element={<NotFound />} />
        <Route
          path='/admin/reset-password'
          element={<PrivateRoute><ResetPassword /></PrivateRoute>}
        />
        <Route
          path='/users/change-password'
          element={<PrivateRoute><ChangePassword /></PrivateRoute>}
        />


        <Route element={<PrivateRoute><AppLayout /></PrivateRoute>}>
          <Route path="/dashboard" element={<DashBoard />} />



          {/* Employees */}
          <Route path="/employees" element={<AllEmployees />} />
          <Route path="/employees/add" element={<EmployeeAdd />} />
          <Route path="/employees/edit/:identy" element={<EmployeeEdit />} />
          <Route path="/employees/:identy" element={<EmployeeDetails />} />

          {/* Assets */}
          <Route path="/assets" element={<AllAsset />} />
          <Route path="/assets/type/:identy" element={<Assets />} />
          <Route path="/assets/add" element={<AssetAdd />} />
          <Route path="/assets/edit/:identy" element={<AssetEdit />} />
          <Route path="/assets/:identy" element={<AssetDetails />} />
          <Route path="/assets/logs/:identy" element={<AssignLogsByAssets />} />
          <Route path="/asset-types" element={<AssetTypePage />} />

          {/* Assignments */}
          <Route path="/assignments" element={<AllAssign />} />
          <Route path="/assignments/name/:identy" element={<Assign />} />
          <Route path="/assignments/add" element={<AssignAsset />} />
          <Route path="/assignments/edit/:identy" element={<AssignEdit />} />
          <Route path="/assignments/:identy" element={<AssignDetails />} />
          <Route path="/assignments/logs" element={<AssignLogs />} />
        </Route>
      </Routes>

      <ToastContainer position="top-right" autoClose={3000}
        transition={Slide}
      //  theme="colored"
      />
    </>
  );
}

export default App;
